/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GcpBigQueryDatasetDetails {
    getFixupPrototypeFunction() { return GcpBigQueryDatasetDetails.fixupPrototype; }

    static newInstance(model: Partial<GcpBigQueryDatasetDetails>): GcpBigQueryDatasetDetails {
        let obj = Object.assign(new GcpBigQueryDatasetDetails(), model);
        GcpBigQueryDatasetDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GcpBigQueryDatasetDetails>): GcpBigQueryDatasetDetails {
        if (!model) return null;
        return GcpBigQueryDatasetDetails.newInstance(<GcpBigQueryDatasetDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GcpBigQueryDatasetDetails) {
        if (!obj) return;

        models.GcpBigQueryDatasetDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GcpBigQueryDatasetDetails): boolean {
        Object.setPrototypeOf(obj, GcpBigQueryDatasetDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * BigQuery dataset id
     */
    dataset_id: string;

    /**
     * BigQuery dataset location (regional or multi-regional)
     */
    dataset_location: string;

}
